var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnsub2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 282,
    viewBox: "0 0 328 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M185.511 281.931C263.475 281.931 326.678 218.818 326.678 140.965C326.678 63.1123 263.475 0 185.511 0C107.546 0 44.3438 63.1123 44.3438 140.965C44.3438 218.818 107.546 281.931 185.511 281.931Z",
    fill: "#8F95AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3874 121.046C76.3874 121.046 80.6272 168.242 70.6183 164.494C60.6094 160.746 55.883 122.503 55.883 122.503C55.883 122.503 39.2015 121.115 33.2935 123.614C33.2935 123.614 50.6005 161.51 43.3024 161.787C36.0042 162.065 13.6927 132.914 13.6927 132.914C13.6927 132.914 2.50222 141.729 0 157.484C0 157.484 34.1276 178.792 32.5984 185.039C31.0693 191.285 5.21297 189.134 5.21297 189.134C5.21297 189.134 11.677 205.375 18.2801 210.927C18.2801 210.927 54.1454 204.126 56.6476 209.956C59.1498 215.855 33.641 223.907 33.641 223.907C33.641 223.907 66.726 254.654 100.506 243.687C100.506 243.687 93.5554 215.786 102.661 215.022C111.766 214.259 121.219 235.359 121.219 235.359C121.219 235.359 152.636 206.902 123.096 164.702C99.1159 130.277 76.3874 121.046 76.3874 121.046ZM106.762 168.381C105.371 176.155 102.035 182.124 99.3939 181.638C96.7527 181.152 95.7101 174.489 97.1002 166.646C98.4903 158.803 101.757 152.903 104.468 153.389C107.179 153.875 108.152 160.607 106.762 168.381Z",
    fill: "#FF2D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.404 279.779C140.404 279.779 86.8841 198.573 58.873 169.908",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.139 205.93L134.328 222.033C133.355 222.241 132.381 221.616 132.103 220.644L122.581 179.903C122.373 178.931 122.998 177.959 123.971 177.682L192.782 161.579C193.756 161.371 194.729 161.996 195.007 162.967L204.529 203.709C204.738 204.75 204.112 205.722 203.139 205.93Z",
    fill: "white",
    stroke: "#22292E",
    strokeWidth: 0.5267,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.848 179.764L162.825 197.948C162.825 197.948 166.161 199.614 168.803 196.56L191.74 164.355",
    stroke: "#22292E",
    strokeWidth: 0.5267,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.834 91.8947C143.296 74.9594 147.744 43.1017 147.744 43.1017C159.004 61.7027 157.475 80.9978 157.475 80.9978L158.24 88.9796L146.215 106.054L125.502 105.637L123.834 91.8947Z",
    fill: "white",
    stroke: "#22292E",
    strokeWidth: 0.666,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.993 98.0719C130.993 98.0719 108.403 76.6252 97.2125 81.4143C86.0915 86.2033 91.4435 94.671 92.9727 95.7815C94.5018 96.892 103.607 96.9614 106.248 103.416C108.959 109.871 114.867 122.781 129.185 128.889C143.434 134.996 160.672 128.333 160.672 128.333C160.672 128.333 173.391 142.701 186.25 144.922C186.25 144.922 201.611 144.366 205.156 133.261C205.156 133.261 205.99 129.374 203.071 128.75C200.151 128.125 159.699 112.162 159.699 112.162C159.699 112.162 185.416 103.833 188.335 83.2189L179.994 81.5531L189.517 77.6663C189.517 77.6663 190.212 66.4224 184.582 53.3045C184.582 53.3045 172.21 68.7822 157.405 81.1366C142.6 93.4911 130.993 98.0719 130.993 98.0719Z",
    fill: "white",
    stroke: "#22292E",
    strokeWidth: 0.666,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1922 89.4655L85.9524 94.8098C85.9524 94.8098 84.7012 96.1979 86.3694 96.7532L92.2079 94.8098L90.1922 89.4655Z",
    fill: "#2C2E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.533 86.0645C129.533 86.0645 129.394 93.4216 145.241 90.1595L136.414 95.4344L130.992 98.0719L123.764 91.9641L129.533 86.0645Z",
    fill: "#2C2E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.324 127.986L164.217 126.32L186.389 144.922C186.32 144.922 170.82 140.965 160.324 127.986Z",
    fill: "#2C2E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.929 93.0052L166.371 92.6581",
    stroke: "#22292E",
    strokeWidth: 0.5267,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.697 98.2107L181.038 98.3495",
    stroke: "#22292E",
    strokeWidth: 0.5267,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6286 89.9513C98.6651 89.9513 99.5053 89.1123 99.5053 88.0774C99.5053 87.0424 98.6651 86.2034 97.6286 86.2034C96.5922 86.2034 95.752 87.0424 95.752 88.0774C95.752 89.1123 96.5922 89.9513 97.6286 89.9513Z",
    fill: "#2C2E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.877 131.457C142.877 131.457 146.352 136.87 152.886 134.094",
    stroke: "#22292E",
    strokeWidth: 0.5267,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.701 134.441L150.037 132.428",
    stroke: "#22292E",
    strokeWidth: 0.5267,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.364 135.621L125.779 175.391",
    stroke: "#22292E",
    strokeWidth: 0.5267,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.293 135.621L190.49 159.775",
    stroke: "#22292E",
    strokeWidth: 0.5267,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.788 107.789C260.788 107.789 248.694 100.918 235.557 102.236C222.351 103.555 218.25 106.748 218.25 106.748C218.25 106.748 218.667 109.177 221.378 108.483C224.089 107.789 234.236 106.054 234.514 107.372C234.792 108.691 227.703 109.108 222.351 112.092C222.351 112.092 222.559 114.799 226.452 113.48C230.9 111.953 237.781 110.635 238.407 111.606C239.102 112.717 236.391 113.341 232.36 115.077C230.761 115.771 229.093 117.159 229.093 117.159C229.093 117.159 230.483 119.796 232.707 118.478C232.707 118.478 238.059 115.493 241.535 117.159C245.01 118.825 251.683 126.737 259.259 126.737",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.788 107.789C260.788 107.789 248.694 100.918 235.557 102.236C222.351 103.555 218.25 106.748 218.25 106.748C218.25 106.748 218.667 109.177 221.378 108.483C224.089 107.789 234.236 106.054 234.514 107.372C234.792 108.691 227.703 109.108 222.351 112.092C222.351 112.092 222.559 114.799 226.452 113.48C230.9 111.953 237.781 110.635 238.407 111.606C239.102 112.717 236.391 113.341 232.36 115.077C230.761 115.771 229.093 117.159 229.093 117.159C229.093 117.159 230.483 119.796 232.707 118.478C232.707 118.478 238.059 115.493 241.535 117.159C245.01 118.825 251.683 126.737 259.259 126.737",
    stroke: "#22292E",
    strokeWidth: 0.5526,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.054 168.173C299.711 164.217 258.494 136.037 258.494 136.037L260.788 107.789C260.788 107.789 295.332 124.724 328 132.914",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.054 168.173C299.711 164.217 258.494 136.037 258.494 136.037L260.788 107.789C260.788 107.789 295.332 124.724 328 132.914",
    stroke: "#22292E",
    strokeWidth: 0.5526,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.459 279.779C233.812 247.097 256.767 205.271 299.371 166.461",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.115 207.022C262.115 207.022 264.352 188.833 263.477 175.605",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.51 232.798C244.51 232.798 246.455 220.251 245.191 207.217",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.066 195.836C271.066 195.836 286.727 190 297.718 191.07",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.639 223.169C250.639 223.169 263.478 217.333 275.248 218.694",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.947 261.979C228.947 261.979 230.698 240.094 222.527 226.67",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.445 269.858C225.445 269.858 240.522 261.59 252.972 264.897",
    stroke: "#2C2E3E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.483 187.374C281.405 187.374 284.584 184.195 284.584 180.273C284.584 176.352 281.405 173.173 277.483 173.173C273.562 173.173 270.383 176.352 270.383 180.273C270.383 184.195 273.562 187.374 277.483 187.374Z",
    fill: "#22292E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.897 199.046C305.819 199.046 308.998 195.867 308.998 191.946C308.998 188.024 305.819 184.845 301.897 184.845C297.976 184.845 294.797 188.024 294.797 191.946C294.797 195.867 297.976 199.046 301.897 199.046Z",
    fill: "#22292E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.419 273.457C262.341 273.457 265.52 270.278 265.52 266.356C265.52 262.434 262.341 259.255 258.419 259.255C254.497 259.255 251.318 262.434 251.318 266.356C251.318 270.278 254.497 273.457 258.419 273.457Z",
    fill: "#22292E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.901 229.88C223.823 229.88 227.002 226.701 227.002 222.78C227.002 218.858 223.823 215.679 219.901 215.679C215.98 215.679 212.801 218.858 212.801 222.78C212.801 226.701 215.98 229.88 219.901 229.88Z",
    fill: "#22292E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.115 191.265C264.855 191.265 267.076 189.044 267.076 186.304C267.076 183.564 264.855 181.343 262.115 181.343C259.375 181.343 257.154 183.564 257.154 186.304C257.154 189.044 259.375 191.265 262.115 191.265Z",
    fill: "#22292E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.826 244.86C239.566 244.86 241.787 242.639 241.787 239.899C241.787 237.159 239.566 234.938 236.826 234.938C234.086 234.938 231.865 237.159 231.865 239.899C231.865 242.639 234.086 244.86 236.826 244.86Z",
    fill: "#22292E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.906 202.256C286.646 202.256 288.867 200.035 288.867 197.295C288.867 194.556 286.646 192.335 283.906 192.335C281.166 192.335 278.945 194.556 278.945 197.295C278.945 200.035 281.166 202.256 283.906 202.256Z",
    fill: "#22292E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.042 230.95C257.964 230.95 261.143 227.771 261.143 223.85C261.143 219.928 257.964 216.749 254.042 216.749C250.12 216.749 246.941 219.928 246.941 223.85C246.941 227.771 250.12 230.95 254.042 230.95Z",
    fill: "#22292E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.604 177.355C266.526 177.355 269.705 174.176 269.705 170.255C269.705 166.333 266.526 163.154 262.604 163.154C258.683 163.154 255.504 166.333 255.504 170.255C255.504 174.176 258.683 177.355 262.604 177.355Z",
    fill: "#22292E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.315 209.454C248.237 209.454 251.416 206.275 251.416 202.353C251.416 198.432 248.237 195.253 244.315 195.253C240.394 195.253 237.215 198.432 237.215 202.353C237.215 206.275 240.394 209.454 244.315 209.454Z",
    fill: "#22292E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.597 226.087C284.518 226.087 287.697 222.908 287.697 218.986C287.697 215.065 284.518 211.886 280.597 211.886C276.675 211.886 273.496 215.065 273.496 218.986C273.496 222.908 276.675 226.087 280.597 226.087Z",
    fill: "#22292E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.897 169.671C305.819 169.671 308.998 166.492 308.998 162.571C308.998 158.649 305.819 155.47 301.897 155.47C297.976 155.47 294.797 158.649 294.797 162.571C294.797 166.492 297.976 169.671 301.897 169.671Z",
    fill: "#22292E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 282,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsub2);
export default __webpack_public_path__ + "static/media/unsub-2.0e5d9265.svg";
export { ForwardRef as ReactComponent };